export class RestoreAzureVmInstanceRequest {
    'restoreAccountId';
    'destination';
    'sapHanaRestore';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AzureVmInstanceRestoreDestination",
            "format": ""
        },
        {
            "name": "sapHanaRestore",
            "baseName": "sapHanaRestore",
            "type": "SapHanaRestoreProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureVmInstanceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
